// A SHORT option set in a NARROW column is a row of choice chips that WRAPS —
// the shell twin of the AI House chip rows (AhChipChoice). Nika 2026-09-24,
// "choice fields: where a select holds few options, use AppFieldSegmented /
// chips".
//
// AppSegmented is the brand TabSet: ONE line (`width: fit-content`), each
// segment at `Z2` type with a `B1` inset on both sides of its label. Four
// ticket types need over 400px that way in English, and more in Georgian;
// the ticket sidebar column is about 238px. A column that narrow takes these
// chips instead: every option is its own capsule, the row wraps, and every
// option stays one tap away in any language.
//
// Nothing here is a new look:
//   AppChoiceChip   the kit's tonal choice chip — AppColorChip without its
//                   dot (a text option carries no colour value): the tonal
//                   fill of its own ink (14 / 22 / 30%), the capsule,
//                   `controlHCompact`, and the chosen chip as the D-1
//                   inversion (`highlight` fill + `highlight-reversed` ink)
//   AppChoiceChips  AppColorChips with those chips: the shared choice
//                   contract (AppChoiceGroup — `options`, `stateKey`,
//                   role=group, aria-pressed) on a wrapping row
// A call site with its own state wiring overrides the chips' `isActive` /
// `ariaPressed` / `onClick` through `childProps`, as with AppSegmented.
//
// AppFieldChips is the FIELD variant: the AppField caption above the row, and
// the group named by the same label. Like AppFieldSegmented it is a `div`: a
// <label> would press its first chip when the caption is clicked.
export const AppChoiceChip = {
  extends: 'AppColorChip',
  Dot: null
}

export const AppChoiceChips = {
  extends: 'AppColorChips',
  childExtends: 'AppChoiceChip'
}

export const AppFieldChips = {
  extends: 'AppField',
  tag: 'div',
  AppChoiceChips: {
    ariaLabel: (el) => el.call('polyglot', el.parent?.label || ''),
    options: (el) => el.parent?.options,
    stateKey: (el) => el.parent?.stateKey
  }
}
